<template>
  <div class="subscription-licences">
    <subscription-licences-list
        v-if="meterDevice"
        :meter-device-id="meterDevice.id"
        :organization-id="meterDevice.organization ? meterDevice.organization.id : null"
    ></subscription-licences-list>
  </div>
</template>

<script>
import SubscriptionLicencesList from "@/components/elements/SubscriptionLicencesList.vue"

export default {
  components: {
    SubscriptionLicencesList,
  },

  computed: {
    meterDevice() {
      return this.$parent.meterDevice ?? null
    },
  },
}
</script>
